import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import Switch from '@/components/Switch';
import { config } from '@/config';
import { PATH } from '@/constants/path';
import { StyledCardHeader, StyledClickAble } from '@/pages/GeneralSetting/styled';
import { emailSettingSelector, handleSaveEmailSettings } from '@/redux/slice/email.slice';
import { BlockStack, Box, Button, Card, Icon, InlineStack } from '@shopify/polaris';
import { BookIcon, ChevronRightIcon, ExternalIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const CustomerNotification = () => {
  const { t } = useTranslation('general_settings');
  const navigate = useNavigate();

  const emailSettings = useSelector(emailSettingSelector);
  const dispatch = useDispatch();

  return (
    <Card>
      <BoldText>{t('sections.emailNotification.customerNoti.title')}</BoldText>
      <RegularText tone="subdued">{t('sections.emailNotification.customerNoti.helpText')}</RegularText>
      <Box paddingBlockStart={'400'}>
        <BlockStack gap={'400'}>
          <Card padding={'0'}>
            <StyledCardHeader>
              <BoldText>{t('sections.emailNotification.customerNoti.emailTitle')}</BoldText>
            </StyledCardHeader>
            <Box padding={'300'}>
              <BlockStack gap={'200'}>
                <InlineStack align="space-between" blockAlign="end">
                  <Box>
                    <BoldText as="p" fontWeight="medium">
                      {t('sections.emailNotification.customerNoti.emailTitle')}
                    </BoldText>
                    <RegularText as="p">{t('sections.emailNotification.customerNoti.emailHelpText')}</RegularText>
                  </Box>
                  <StyledClickAble
                    onClick={() =>
                      window.open(`https://admin.shopify.com/store/${config.storeName}/email_templates/order_confirmation/edit`)
                    }
                  >
                    <Icon source={ExternalIcon} />
                  </StyledClickAble>
                </InlineStack>
                <Box>
                  <Button
                    icon={BookIcon}
                    onClick={() =>
                      window.open(
                        'https://help.omegatheme.com/en/article/how-to-confirm-selected-schedule-in-order-confirmation-email-phdc64/?bust=1750304640177',
                        '_blank',
                      )
                    }
                  >
                    {t('sections.emailNotification.customerNoti.emailGuide')}
                  </Button>
                </Box>
              </BlockStack>
            </Box>
          </Card>

          <Card padding={'0'}>
            <StyledCardHeader>
              <BoldText>{t('sections.emailNotification.storePickup.title')}</BoldText>
            </StyledCardHeader>
            <StyledClickAble onClick={() => navigate(PATH.CUSTOM_NOTI_PICKUP_EMAIL.pathname)}>
              <Box padding={'300'}>
                <BlockStack gap={'050'}>
                  <RegularText fontWeight="medium">{t('sections.emailNotification.storePickup.label')}</RegularText>
                  <InlineStack align="space-between" blockAlign="center" gap={'200'}>
                    <RegularText>{t('sections.emailNotification.storePickup.helpText')}</RegularText>
                    <InlineStack gap={'300'} blockAlign="center">
                      <Switch
                        isActive={emailSettings.isEnableReadyForPickup}
                        onSwitch={() => {
                          dispatch(handleSaveEmailSettings({ isEnableReadyForPickup: !emailSettings.isEnableReadyForPickup }));
                        }}
                      />
                      <Box>
                        <Icon source={ChevronRightIcon} />
                      </Box>
                    </InlineStack>
                  </InlineStack>
                </BlockStack>
              </Box>
            </StyledClickAble>
          </Card>

          <Card padding={'0'}>
            <StyledCardHeader>
              <BoldText>{t('sections.emailNotification.deliveryAndShipping.title')}</BoldText>
            </StyledCardHeader>
            <StyledClickAble onClick={() => navigate(PATH.CUSTOM_NOTI_DELIVERY_SHIPPING_EMAIL.pathname)}>
              <Box padding={'300'}>
                <BlockStack gap={'050'}>
                  <RegularText fontWeight="medium">{t('sections.emailNotification.deliveryAndShipping.label')}</RegularText>
                  <InlineStack align="space-between" blockAlign="center" gap={'200'}>
                    <RegularText>{t('sections.emailNotification.deliveryAndShipping.helpText')}</RegularText>
                    <InlineStack gap={'300'} blockAlign="center">
                      <Switch
                        isActive={emailSettings.isEnableOutForDelivery}
                        onSwitch={() =>
                          dispatch(handleSaveEmailSettings({ isEnableOutForDelivery: !emailSettings.isEnableOutForDelivery }))
                        }
                      />
                      <Box>
                        <Icon source={ChevronRightIcon} />
                      </Box>
                    </InlineStack>
                  </InlineStack>
                </BlockStack>
              </Box>
            </StyledClickAble>
          </Card>
        </BlockStack>
      </Box>
    </Card>
  );
};
